import { collection, doc, onSnapshot } from "firebase/firestore";
import React, { useEffect, useState } from "react";
import { db } from "../../config/firebaseConfig";
import { HOSTNAME } from "../../config/constants";
import { useParams } from "react-router-dom";
import { sortArray } from "../../functions/sort";
import SplashScreen from "../../layout/SplashScreen";
import useWindowSize from "../../hooks/useWindowSize";
import { getTime } from "../../functions/time";

import CheckRoundedIcon from "@mui/icons-material/CheckRounded";
import DoneAllRoundedIcon from "@mui/icons-material/DoneAllRounded";
import ExpandLessRoundedIcon from "@mui/icons-material/ExpandLessRounded";
import ExpandMoreRoundedIcon from "@mui/icons-material/ExpandMoreRounded";
import { useSelector } from "react-redux";

import AutorenewRoundedIcon from "@mui/icons-material/AutorenewRounded";
import AccessTimeRoundedIcon from "@mui/icons-material/AccessTimeRounded";
import RoomServiceRoundedIcon from "@mui/icons-material/RoomServiceRounded";
import ButtonPrimary from "../../components/buttons/ButtonPrimary";

const Orders = () => {
  const { outlet, table } = useParams();
  const [activeOrdersList, setactiveOrdersList] = useState([]);
  const [deliveredOrdersList, setdeliveredOrdersList] = useState([]);

  const [loadingActive, setloadingActive] = useState(true);
  const [loadingDelivered, setloadingDelivered] = useState(true);
  const [ordersTotalList, setordersTotalList] = useState(null);

  const { width } = useWindowSize();

  useEffect(() => {
    const menuDataRef = doc(db, "orders", HOSTNAME);
    const outletRef = doc(menuDataRef, "outlet", outlet);

    const activeOrdersRef = collection(outletRef, "currentOrders");
    const deliveredOrdersRef = collection(outletRef, "deliveredOrders");

    const unsubscribeActiveOrders = onSnapshot(activeOrdersRef, (snapshot) => {
      let itemsArray = [];

      const localOrders = JSON.parse(localStorage.getItem("yourOrders"));

      snapshot.forEach((doc) => {
        if (
          table &&
          doc.data().tableNo === table &&
          localOrders &&
          localOrders.table === table &&
          localOrders.orders.includes(doc.data().orderId)
        ) {
          itemsArray.push({ ...doc.data() });
        }
      });

      setactiveOrdersList(sortArray(itemsArray, "orderedAt", true));
      setloadingActive(false);
    });

    const unsubscribeDeliveredOrders = onSnapshot(deliveredOrdersRef, (snapshot) => {
      let itemsArray = [];
      const localOrders = JSON.parse(localStorage.getItem("yourOrders"));
      snapshot.forEach((doc) => {
        if (
          table &&
          doc.data().tableNo === table &&
          localOrders &&
          localOrders.table === table &&
          localOrders.orders.includes(doc.data().orderId)
        ) {
          itemsArray.push({ ...doc.data() });
        }
      });

      setdeliveredOrdersList(sortArray(itemsArray, "orderedAt", true));
      setloadingDelivered(false);
    });

    return () => {
      unsubscribeActiveOrders();
      unsubscribeDeliveredOrders();
    };
  }, []);

  // useEffect(() => {
  //   const currentOrdersListClone = JSON.parse(JSON.stringify(deliveredOrdersList));
  //   const currentOrderArray = currentOrdersListClone.filter((item) => item.tableNo === table);

  //   if (currentOrderArray.length === 0) {
  //     setordersTotalList(null);
  //   } else {
  //     let orderItemsObj = {};
  //     currentOrderArray.forEach((order) => {
  //       order.items.forEach((item) => {
  //         if (orderItemsObj[item.id]) {
  //           orderItemsObj[item.id].qty = orderItemsObj[item.id].qty + item.qty;
  //         } else {
  //           orderItemsObj[item.id] = item;
  //         }
  //       });
  //     });

  //     const orderItemsArray = Object.values(orderItemsObj);

  //     const totalQty = getTotalQuantity(orderItemsArray);
  //     const totalPrice = getTotalPrice(orderItemsArray);

  //     const ordersTotalData = {
  //       status: "delivered",
  //       tableNo: table,
  //       items: orderItemsArray,
  //       totalQty,
  //       totalPrice,
  //     };

  //     setordersTotalList(ordersTotalData);
  //   }
  // }, [deliveredOrdersList]);

  function getTotalQuantity(array) {
    let total = 0;

    array.forEach((el) => {
      total = total + el.qty;
    });

    return total;
  }

  function getTotalPrice(array) {
    let total = 0;

    array.forEach((el) => {
      total = total + el.qty * el.price;
    });

    return total.toFixed(2);
  }

  return loadingActive || loadingDelivered ? (
    <SplashScreen height={width <= 600 ? "calc(100vh - 7.5rem)" : "100vh"} />
  ) : activeOrdersList.length || deliveredOrdersList.length ? (
    <div className="orders-page">
      {/* {ordersTotalList && (
        <div className="grid-orders" style={{ gridTemplateColumns: "repeat(1, 1fr)" }}>
          <OrderTotalCard data={ordersTotalList} />
        </div>
      )} */}
      <p className="bold uppercase grey ml-2">YOUR ORDERS </p>
      <div className="grid-orders">
        {activeOrdersList.map((order) => (
          <OrderRestaurantCard key={order.orderId} data={order} />
        ))}
        {deliveredOrdersList.map((order) => (
          <OrderRestaurantCard key={order.orderId} data={order} />
        ))}
      </div>
    </div>
  ) : (
    <div className="empty-orders-order">
      <p className="message">No orders yet 🍕</p>
    </div>
  );
};

function OrderTotalCard(props) {
  const { data } = props;
  const { outlet, table } = useParams();

  const [isOpen, setisOpen] = useState(true);
  const { activeOutlet } = useSelector((state) => state.config);

  return (
    <div className="order-card">
      <div className="order-restaurant-header">
        <div className="flex g-2">
          <div className="order-time">
            <p>Table {table} Total</p>
          </div>
        </div>
        <div className="btn-expand" onClick={() => setisOpen((prev) => !prev)}>
          {isOpen ? <ExpandLessRoundedIcon /> : <ExpandMoreRoundedIcon />}
        </div>
      </div>

      {isOpen && (
        <div className="order-restaurant-content">
          <div className="total-card">
            <div className="header">
              <p className="name">NAME</p>
              <p className="qty">QTY</p>
              <p className="price">PRICE</p>
            </div>
            <div className="mb-2">
              {data.items.map((item) => (
                <div key={item.id} className="content">
                  <p className="name">{item.name}</p>
                  <p className="qty">{item.qty}</p>
                  <p className="price">
                    {activeOutlet.outletCurrency} {(item.price * item.qty).toFixed(2)}
                  </p>
                </div>
              ))}
            </div>

            <div className="line" />
            <div className="total">
              <p className="total-text">TOTAL</p>
              <p className="qty">{data.totalQty}</p>
              <p className="price">
                {activeOutlet.outletCurrency} {data.totalPrice}
              </p>
            </div>
            {/* <div className="flex g-1">
              <ButtonPrimary
                text=""
                size="sm"
                variant="success"
                onClick={() => {
                  //   updateStatus(data.orderId, "completed");
                }}
              />
            
            </div> */}
          </div>
        </div>
      )}
    </div>
  );
}

function OrderRestaurantCard(props) {
  const { data } = props;
  const [isOpen, setisOpen] = useState(window.innerWidth <= 600 ? false : true);
  const { activeOutlet } = useSelector((state) => state.config);

  const { width } = useWindowSize();

  useEffect(() => {
    width <= 600 ? setisOpen(false) : setisOpen(true);
  }, [width]);

  return (
    <div className="order-card">
      <div className="order-restaurant-header">
        <div className="flex g-2">
          <div className="order-time">
            <AccessTimeRoundedIcon />
            <p>{getTime(data.orderedAt)}</p>
          </div>

          {data.tableNo === "takeaway" ? (
            <div className="order-table">
              <p className="order-table">Take Away</p>
            </div>
          ) : (
            <div className="order-table">
              <p>Table {data.tableNo}</p>
            </div>
          )}
          {data.status === "ordered" ? (
            <div className="order-status">
              <div className="status-icon" style={{ backgroundColor: "var(--color-primary)" }}>
                <RoomServiceRoundedIcon />
              </div>
              <p>Order Requested</p>
            </div>
          ) : data.status === "confirmed" ? (
            <div className="order-status">
              <div className="status-icon" style={{ backgroundColor: "var(--color-secondary)" }}>
                <AutorenewRoundedIcon />
              </div>
              <p>In Progress</p>
            </div>
          ) : data.status === "delivered" ? (
            <div className="order-status">
              <div className="status-icon" style={{ backgroundColor: "var(--color-success)" }}>
                <CheckRoundedIcon />
              </div>
              <p>Delivered</p>
            </div>
          ) : data.status === "completed" ? (
            <div className="order-status">
              <div className="status-icon" style={{ backgroundColor: "var(--color-success)" }}>
                <DoneAllRoundedIcon />
              </div>
              <p>Completed</p>
            </div>
          ) : (
            <div className="order-status">
              <div className="status-icon" style={{ backgroundColor: "var(--color-danger)" }}>
                <DoneAllRoundedIcon />
              </div>
              <p>Cancelled</p>
            </div>
          )}
        </div>
        <div className="btn-expand" onClick={() => setisOpen((prev) => !prev)}>
          {isOpen ? <ExpandLessRoundedIcon /> : <ExpandMoreRoundedIcon />}
        </div>
      </div>

      {isOpen && (
        <div className="order-restaurant-content">
          <p className="order-id">Order ID - {data.orderId}</p>

          <div className="total-card">
            <div className="header">
              <p className="name">NAME</p>
              <p className="qty">QTY</p>
              <p className="price">PRICE</p>
            </div>
            <div>
              {data.items.map((item) => (
                <div key={item.id} className="content">
                  <p className="name">{item.name}</p>
                  <p className="qty">{item.qty}</p>
                  <p className="price">
                    {activeOutlet.outletCurrency} {(item.price * item.qty).toFixed(2)}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default Orders;
